import React, { useContext, useEffect, useState } from 'react'
import SideBarLayout from '../../../global/layout/SideBarLayout';
import { MyContext } from '../../../context';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import DetailsHeaderTabs from '../locationDetail/DetailsHeaderTabs';
import { emptyFunction, getCompanyName, handleTabs, showToast } from '../../../utils';
import { endPoints } from '../../../utils/endpoints';
import { makeDeleteCall, makeGetCall, makeNextPageCall, makePatchCall, makePostCall } from '../../../effects/requests';
import { ApiResponseType } from '../../../types';
import FolderGridView from './FolderGridView';
import DeleteFolderPopup from './DeleteFolderPopup';
import AddFolder from './AddFolder';
import CreateCollections from '../collections/CreateCollections';
import AsignLocationToCollection from '../collections/AsignLocationToCollection';
import AsignLocationToPerScript from '../perScript/AsignLocationToPerScript';


const Dummy = () => (<div
    style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: '18px',
        color: 'black',
        textAlign: 'center',
        width: '100%',
        padding: '0 16px',
        boxSizing: 'border-box',
        fontWeight: 600
    }}
>
    Coming Soon, Please visit <a
        href="https://www.sixthdegree.io/locations"
        target="_blank"
        rel="noopener noreferrer"
    >
        www.sixthdegree.io/locations
    </a> for locations already on baord.
</div>)

export type SubTab = 'info' | 'vault' | 'sixthdegree';

const LocationFolders = (props: any) => {

    const { userData } = useContext(MyContext);

    const params = useParams();
    const { state } = useLocation();
    const locationId = params?.id || '';
    const vaultType = params?.type || '';
    const locationData = state?.location;
    const navigate = useNavigate();

    const [topTab, setTopTab] = useState<any>('gallery');
    const [subTab, setSubTab] = useState<SubTab>('info');
    const [isGridView, setIsGridView] = useState(true);
    const [allFolders, setAllFolders] = useState([]);
    const [nextUrl, setNextUrl] = useState<string | null>(null);
    const [selectedFolderId, setSelectedFolderId] = useState<any>(null);
    const [showAddFolder, setShowAddFolder] = useState<any>(false);
    const [newFolderName, setNewFolderName] = useState('');
    const [showCreateCollection, setShowCreateCollection] = useState(false);
    const [asignLocCollection, setAsignLocCollection] = useState<any>(null);
    const [asignLocToScript, setAsignLocToScript] = useState<any>(null);

    const fetchFolders = () => {
        const url = `${endPoints.LOCATION_FOLDER}?location_id=${locationId || locationData?.location?.id || ''}`
        makeGetCall(url).then((res: ApiResponseType<any>) => {
            const list = res?.results?.length > 0 ? res?.results : []
            setAllFolders(res?.results);
            setNextUrl(res?.next || null);
        }).catch(emptyFunction)
    }

    const fetchMoreData = () => {
        if (!nextUrl) return;
        makeNextPageCall(nextUrl, false, true).then((res: ApiResponseType<any>) => {
            const data: any = [...allFolders, ...res.results];
            setAllFolders(data);
            setNextUrl(res?.next);
        })
    }

    useEffect(() => {
        if (userData?.id)
            fetchFolders();
    }, [userData?.id]);

    const moveItem = (from: number, to: number) => {
        // @ts-ignore
        setAllFolders((prev: any) => {
            const updated = [...prev];
            const [removed] = updated.splice(from, 1);
            updated.splice(to, 0, removed);
            return updated;
        });
    };

    const onThumbnail = (selectedFolder: any) => {
        const fd = {
            location_thumbnail: true,
            folder_id: selectedFolder?.id || '',
            production_company_name: getCompanyName(userData),
        }
        makePatchCall(endPoints.LOCATION_FOLDER_IMAGE, fd).then(emptyFunction, emptyFunction)
    }

    const handleRemoveFolder = () => {
        if (!selectedFolderId) return;

        const url = `${endPoints.LOCATION_FOLDER}${selectedFolderId}/`;

        makeDeleteCall(url)
            .then((res: ApiResponseType) => {
                if (res?.status?.code === 200) {
                    showToast(res.status.message, "success");
                    setAllFolders(prev => prev.filter((folder: any) => folder?.id !== selectedFolderId));
                    setSelectedFolderId(null);
                }
            })
            .catch(emptyFunction);
    };

    const createFolder = () => {
        if (!newFolderName?.trim()) {
            showToast('Enter folder name.', 'error')
            return;
        }
        const folderPayload = {
            location_id: locationData?.id,
            name: newFolderName?.trim() || "",
            production_company_name: getCompanyName(userData),
            my_vault: vaultType == 'myvault' ? true : false,
        };

        makePostCall(endPoints.LOCATION_FOLDER, folderPayload).then((res: ApiResponseType<any>) => {
            setNewFolderName('');
            setShowAddFolder(false)
            if (res?.status?.code == 200) {
                showToast(res?.status?.message, 'success');
                const templist = [...allFolders]
                templist.push(res?.data as never);
                setAllFolders(templist)
            }
        });
    }

    return (
        <SideBarLayout>
            <div className="right-content-full-screen">
                <div className="ld-page ">

                    <div className="ld-header">
                        <div className="ld-header__left">
                            <h1 className="ld-header__title">{locationData?.name || ''}</h1>
                            <div className="ld-breadcrumb">
                                <button className="ld-breadcrumb__link" onClick={() => navigate(vaultType === 'myvault' ? '/location/myvault' : '/location/vault')}>
                                    {vaultType === 'myvault' ? "My Vault" : 'Location Vault'}
                                </button>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                                <span className="ld-breadcrumb__current">{locationData?.name || ''}</span>
                            </div>
                        </div>

                        <DetailsHeaderTabs
                            setTopTab={(type: any) => {
                                const route = handleTabs(type);
                                setTopTab(type)
                                if (route) {
                                    navigate(`${route}/${vaultType}/${locationId}`, {
                                        replace: true,
                                        state: { location: locationData },
                                    });
                                }
                            }}
                            topTab={topTab}
                        />

                        <div className="ld-header__actions">
                            {!props?.hideAsign &&
                                <>
                                    <button
                                        type='button'
                                        onClick={() => {
                                            setAsignLocCollection({ location: locationData, id: locationId })
                                        }}
                                        className="ld-btn-assign"
                                    >
                                        Assign Location
                                    </button>
                                    <button
                                        type='button'
                                        onClick={() => {
                                            setAsignLocToScript({ location: locationData, id: locationId })
                                        }}
                                        className="ld-btn-assign"
                                    >
                                        Assign to script
                                    </button>
                                </>
                            }
                            <button
                                type='button'
                                onClick={() => {
                                    showToast('coming soon.', 'info')
                                }}
                                className="ld-btn-icon"
                                aria-label="Share"
                            >
                                <img src="/assets/images/upload-share-icon.svg" alt="Share" />
                            </button>
                        </div>

                    </div>

                    <div className="la-wrap">
                        <div className="la-subtabs-bar">
                            <div className="la-subtabs">
                                <button
                                    className={`la-subtab${subTab === 'info' ? ' la-subtab--active' : ''}`}
                                    onClick={() => setSubTab?.('info')}
                                >
                                    Production Folders
                                </button>
                                <button
                                    className={`la-subtab${subTab === 'vault' ? ' la-subtab--active' : ''}`}
                                    onClick={() => setSubTab?.('vault')}
                                >
                                    Location Vault
                                </button>
                                <button
                                    className={`la-subtab${subTab === 'sixthdegree' ? ' la-subtab--active' : ''}`}
                                    onClick={() => setSubTab?.('sixthdegree')}
                                >
                                    6th Degree Photos
                                </button>
                            </div>

                            <div className="la-subtabs-action">
                                <div className="lg-bar__right">
                                    {locationData?.role != 'V' &&
                                        <button
                                            type='button'
                                            onClick={() => setShowAddFolder(true)}
                                            className="la-btn-action"
                                        >
                                            <img src='/assets/images/folders.svg' />
                                            Add Folder
                                        </button>
                                    }
                                    {/* <div className="lv-view-btn-wrap">
                                        <button
                                            className={`lv-view-toggle-btn ${isGridView ? "active" : ""}`}
                                            onClick={() => setIsGridView(true)}
                                        >
                                            <img src={isGridView ? '/assets/images/folders.svg' : '/assets/images/folders-inactive.svg'} />
                                        </button>

                                        <button
                                            className={`lv-view-toggle-btn ${!isGridView ? "active" : ""}`}
                                            onClick={() => setIsGridView(false)}
                                        >
                                            <img src={!isGridView ? '/assets/images/list-view-active.svg' : '/assets/images/list-view.svg'} />
                                        </button>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {subTab == 'vault' || subTab == 'sixthdegree'
                        ?
                        <Dummy />
                        :
                        <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                            <FolderGridView
                                allFolders={allFolders}
                                onDelete={(folder: any) => setSelectedFolderId(folder?.id)}
                                moveItem={moveItem}
                                onThumbnail={onThumbnail}
                                locationId={locationData?.id}
                                onViewImg={(folder: any) =>
                                    navigate(`/location-gallery/${vaultType}/${locationId}`, {
                                        replace: true,
                                        state: { location: locationData, folderData: folder },
                                    })
                                }
                                locationData={locationData}
                            />
                        </div>
                    }

                </div>

                {selectedFolderId &&
                    <DeleteFolderPopup
                        onClose={() => setSelectedFolderId(null)}
                        onDelete={handleRemoveFolder}
                    />
                }

                {showAddFolder &&

                    <AddFolder
                        onClose={() => {
                            setNewFolderName('');
                            setShowAddFolder(false)
                        }}
                        setNewFolderName={setNewFolderName}
                        newFolderName={newFolderName}
                        onDone={createFolder}
                    />

                }

                {showCreateCollection &&
                    <CreateCollections
                        onClose={() => setShowCreateCollection(false)}
                        onDone={() => {
                            setShowCreateCollection(false)
                        }}
                    />
                }

                {asignLocCollection?.id &&
                    <AsignLocationToCollection
                        onClose={() => setAsignLocCollection(null)}
                        onCreate={() => {
                            setAsignLocCollection(null);
                            setShowCreateCollection(true)
                        }}
                        locationData={asignLocCollection}
                        production_company_name={getCompanyName(userData)}
                    />
                }

                {asignLocToScript?.id &&
                    <AsignLocationToPerScript
                        onClose={() => setAsignLocToScript(null)}
                        onCreate={() => {
                            setAsignLocToScript(null);
                        }}
                        locationData={asignLocToScript}
                        production_company_name={getCompanyName(userData)}
                    />
                }

            </div>
        </SideBarLayout>
    )
}

export default LocationFolders